
<template>
  <div>
    <div class="item-box-content mainStep">
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>收款申请</span>
          </div>
        </el-col>
      </el-row>
      <el-form label-width="100px" style="margin-top:20px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款类型：">{{receiptType}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="150px" label="可申请收款金额：">{{money.toFixed(2)}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收款方式：" v-if="state === 'pay'">{{'银行转账'}}</el-form-item>
            <el-form-item label="收款方式：" v-else>
              <el-radio-group @change="payeeTypeChange" v-model.trim="params.payeeType">
                <el-radio :label="1">银行转账</el-radio>
                <el-radio :label="2">承兑汇票</el-radio>
                <el-radio :label="3">账户余额</el-radio>
                <el-radio :label="4">抵扣金额</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款金额：">
              <el-input-number
                v-model.trim="params.receiprMoney"
                :controls="false"
                :max="money"
                :precision="2"
                :min="0.01"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input
                type="textarea"
                v-model.trim="params.mark"
                :controls="false"
                :precision="2"
                :min="0"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="params.payeeType ===1" class="item-box-content">
      <div class="title-font-style">
        <span>银行账户</span>
      </div>
      <el-form label-width="100px" style="margin-top:20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账户名称：">
              {{suNameList.suName}}
              <el-button type="text" @click="onAddAccount" style="margin-left:10px">
                <i class="el-icon-plus"></i>添加账户
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：">
              <el-select
                @change="changeBank"
                v-model.trim="params.receiptBankNumber"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in contractScreenCondition"
                  :key="index"
                  :label="item.bankCode"
                  :value="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开户银行：">
              <el-input disabled v-model.trim="params.receiptOpenBank"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行行号：">
              <el-input disabled v-model.trim="params.receiptOpenNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="params.payeeType ===2" class="item-box-content" style="padding-bottom:0;">
      <div class="title-font-style">
        <span>承兑汇票</span>
      </div>
      <el-form label-width="100px" style="margin-top:20px;">
        <el-row :gutter="20">
          <el-col :span="13">
            <el-form-item label="承兑票号：">
              <el-input v-model.trim="params.billNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出票单位：">
              <el-input v-model.trim="suNameList.suName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出票银行：">
              <el-input v-model.trim="params.billBank"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出票日期：">
              <el-date-picker v-model.trim="params.billDate" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期日期：">
              <el-date-picker v-model.trim="params.billEnddate" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传凭证：">
              <div class="upload-pictures">
                <el-upload
                  action="Fake Action"
                  :on-change="handleChange"
                  :before-upload="beforeUploadFile"
                  :on-remove="handleRemove"
                  :http-request="allUpload"
                  multiple
                  :limit="1"
                  class="upload-demo"
                  drag
                  ref="upload"
                  :file-list="fileList"
                  :on-exceed="onExceed"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                </el-upload>
              </div>
              <div>支持上传pdf、png和jpeg，最多可上传1个附件且不超过10M</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!------------ 添加账户 ------------>
    </div>
    <el-button type="primary" @click="onSubmit">提交信息</el-button>
    <add-bank-account-dialog @addAccountDialog="addAccountDialog" ref="addBankAccountDialogRefs"></add-bank-account-dialog>
  </div>
</template>
<script>
import { financeUploadFile } from '@/api/fiance/fianceManage'
import addBankAccountDialog from '@/components/AddAccount/addAccountDialog'
import {
  queryBySuId, addRetreatReceipt
} from '@/api/purchase/purchasePlanList'
import { isSuccess } from '@/util/tool'
export default {
  components: {
    'add-bank-account-dialog': addBankAccountDialog
  },
  props: ['money', 'suNameList', 'pcrsId', 'receiptType'],
  data () {
    return {
      contractScreenCondition: [],
      queryParams: {},
      state: 'payee',

      uploadFileType: ['pdf', 'png', 'jpeg'],
      fileList: [],
      params: {
        billBank: '',
        billCompany: '',
        billDate: '',
        billEnddate: '',
        billNumber: '',
        mark: '',
        payeeType: 1,
        receiprMoney: undefined,
        receiptBankId: 0,
        receiptBankNumber: '',
        receiptName: '',
        receiptOpenBank: '',
        receiptOpenNumber: '',
        receiptType: ''
      },
      ruleForm: []
    }
  },
  methods: {
    // radio change
    payeeTypeChange () {

    },
    onSubmit () {
      if (this.fileList.length === 1) {
        this.params.billAttachment = this.fileList[0].id
      }
      this.params.receiptType = this.receiptType
      this.params.pcrsId = this.pcrsId
      this.params.billCompany = this.suNameList.suName
      this.params.receiptName = this.suNameList.suName
      if (this.params.mark === '') {
        this.$message.error('备注不能为空!')
      } else if (this.params.payeeType === 2 && (this.params.billNumber === '' || this.params.billBank === '' || this.params.billEnddate === '' || this.params.billDate === '')) {
        this.$message.error('请填写完整信息!')
      } else if (this.params.payeeType === 1 && this.params.receiptBankNumber === '') {
        this.$message.error('请选择银行账号!')
      } else {
        addRetreatReceipt(this.params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$emit('getList')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    getList (type) {
      if (type === 1) {
        this.state = 'pay'
      } else {
        this.state = 'payee'
      }
      this.params = {
        billBank: '',
        billCompany: '',
        billDate: '',
        billEnddate: '',
        billNumber: '',
        mark: '',
        payeeType: 1,
        receiprMoney: undefined,
        receiptBankId: 0,
        receiptBankNumber: '',
        receiptName: '',
        receiptOpenBank: '',
        receiptOpenNumber: '',
        receiptType: ''
      }
      this.params.receiprMoney = this.money
      queryBySuId(this.suNameList.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractScreenCondition = res.data.obj
            if (this.contractScreenCondition.length !== 0) {
              this.params.receiptBankNumber = this.contractScreenCondition[0].bankCode
              this.params.receiptOpenBank = this.contractScreenCondition[0].bankOpencount
              this.params.receiptOpenNumber = this.contractScreenCondition[0].bankOpenCode
              this.params.receiptBankId = this.contractScreenCondition[0].id
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 添加账户
    onAddAccount () {
      this.$refs.addBankAccountDialogRefs.onInitial(this.suNameList)
    },
    onExceed () {
      this.$message.error('至多上传1个文件！')
    },
    handleRemove (file) {
      this.fileList = this.fileList.filter(item => {
        return item.id !== file.id
      })
      this.ruleForm = this.ruleForm.filter(items => {
        return items.guid !== file.id
      })
    },
    // 银行账户change
    changeBank () {
      this.contractScreenCondition.forEach((element) => {
        if (element.bankCode === this.params.receiptBankNumber) {
          this.params.receiptOpenBank = element.bankOpencount
          this.params.receiptOpenNumber = element.bankOpenCode
          this.params.receiptBankId = element.id
        }
      })
    },
    // 请求银行账户
    bankList () {
      queryBySuId(this.suNameList.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractScreenCondition = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addAccountDialog () {
      this.bankList()
    },
    async allUpload () {
      var formData = new FormData()
      const { fileList } = this
      const len = fileList.length - 1
      formData.append('MultipartFile[]', fileList[len].raw)
      await financeUploadFile(formData).then((res) => {
        console.log(res)
        if (isSuccess(res)) {
          this.ruleForm.push(...res.data.obj)
          Object.assign(this.fileList[len], {
            id: res.data.obj[0].guid
          })
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
          this.fileList = []
        }
      })
    },
    beforeUploadFile (file) {
      const { uploadFileType } = this
      const filearr = file.name.split('.')
      const filetype = filearr[filearr.length - 1]
      if (file.size === 0) {
        this.$message.error('文件内容为空')
        return false
      } else if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件过大')
        return false
      } else if (uploadFileType.includes(filetype)) {
        return true
      }
      this.$message.error('请上传正确的文件')
      return false
    },
    handleChange (file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>
